import "./sidebar.scss";

import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";

class SidebarPopoverList extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const children = [];
    this.props.options.forEach((g, gIndex) => {
      const groupChildren = g.map((o, index) => (
        <div
          className={`sidebarPopoverListItem ${o.selected ? "selected" : ""} ${o.disabled ? "disabled" : ""}`}
          key={index}
          onClick={
            o.disabled
              ? null
              : () => {
                this.props.onClick(o.id);
              }
          }
        >
          <svg className={"icon " + (o.color ? o.color : "iconMono")}>
            <use xlinkHref={"#" + (o.icon ? o.icon : "blank")} />
          </svg>
          <span>{o.label}</span>
          {o.shortcut ? <span className="shortcut">{o.shortcut}</span> : null}
        </div>
      ));

      if (groupChildren.length) {
        children.push(
          <div key={gIndex} className="sidebarPopoverListGroup">
            {groupChildren}
          </div>
        );
      }
    });

    const classes = [this.props.className || "", "sidebarPopoverList"];
    return <div className={classes.join(" ")}>{children}</div>;
  }
}

SidebarPopoverList.propTypes = {
  options: PropTypeShapes.popoverListGroupArray.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string
};

export default SidebarPopoverList;
